<template>
    <div class="wrapper bg-dark-blue dark-bar pb-2 pb-md-0">
        <div class="container">
            <div class="padding-20 d-flex justify-content-between align-items-center">
                <div class="icon bridge-fee-icon"></div>
                <!-- <a href="https://taxa-pod-fetesti.ro/ro/?from=beta" class="d-md-block d-none btn btn-header">Versiune veche Taxa-pod-fetești</a> -->
                <div class="d-flex about-vignette">
                    <div class="icon danger-sign-icon"></div>
                    <span v-if="isDesktop()" @click="openModal('peajModal')">
                        {{ $t('about') + ' ' + capitalize($t('site_tpf')) }}
                    </span>
                    <span v-else @click="openModal('peajModal')">{{ $t('info') }}</span>
                </div>
            </div>
        </div>
        <!-- <a href="https://taxa-pod-fetesti.ro/ro/?from=beta" class="d-block d-md-none btn btn-header">Versiune veche Taxa-pod-fetești</a> -->
        <div class="modal" id="peajModal" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title heading-small">
                            {{ $t('about') + ' ' + capitalize($t('site_tpf')) }}
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <div class="icon icon-x"></div>
                        </button>
                    </div>
                    <div class="modal-body px-0 pt-0">
                        <div class="default-content">
                            <AboutPeajContent/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TCPCModal from '../components/snippets/TCPCModal.vue'
import Heading from './snippets/Heading.vue'
import AboutPeajContent from './AboutPeajContent.vue'

export default {
    name: 'TaxaPodFetestiNavigation',
    mixins: [
        TCPCModal
    ],
    props: {
    },
    components: {
        AboutPeajContent,
        Heading
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .modal-body {
        .default-content {
            padding-top: 16px;
        }
        height: 675px;
    }
</style>
